import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-slider-type',
  templateUrl: './slider-type.component.html',
  styleUrls: ['./slider-type.component.scss']
})
export class SliderTypeComponent extends FieldType {  
  valueChangeHandler(value) {
    this.formControl.setValue(value.toString());
  }

  formatLabel(value: number): string {
    return `${value}h`;
  }
}
